import React from "react";

const isLocal = process.env.NODE_ENV !== "production";

const GlobalThemeComponent = !isLocal
  ? () => null
  : React.lazy(() =>
      import("@tvg/fuse-themes").then((m) => ({
        default: m.GlobalThemeComponent,
      })),
    );

interface BrandType {
  brand?: "default" | "littlewoods" | "very" | "veryireland";
}

export const ThemeComponent = !isLocal
  ? () => null
  : (props: BrandType) => {
      let { brand } = props;

      brand = brand === "veryireland" ? "very" : brand;

      if (typeof window === "undefined") return null;

      return (
        <React.Suspense fallback={null}>
          <GlobalThemeComponent brand={brand} />
        </React.Suspense>
      );
    };
